import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Urls from '../../components/Url/Urls';

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.product.notification }),
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: () => 'getNotifications',
    })
  })
});

export const { useGetNotificationsQuery } = notificationsApi;
export const { middleware } = notificationsApi;
